/**
 * Prefer structured multi-country location (city + admin1) when present,
 * falling back to the legacy free-text `location` string — never drops data.
 */
export function formatJobLocation(job) {
  if (!job) return "";
  if (job.city && job.country_code) {
    return job.admin1_name ? `${job.city}, ${job.admin1_name}` : job.city;
  }
  return job.location || "";
}
